import domready from 'domready';
domready(function () {
  var overlay = document.querySelector("label[for=\"selector-state\"]");
  var buttons = document.getElementsByClassName("room-selector");
  Array.prototype.forEach.call(buttons, function (el, i) {
    var links = JSON.parse("[" + el.dataset.links + "]");
    var rooms = JSON.parse("[" + el.dataset.titles + "]");
    var bookable = JSON.parse("[" + el.dataset.bookable + "]");
    var wrapContent = "";
    var openWrap = "<div class=\"room-select\">" + "<label class=\"room-select__close\" for=\"selector-state\"><svg height=\"48\" width=\"48\" viewBox=\"0 0 48 48\" preserveAspectRatio=\"xMidYMid meet\"><use xlink:href=\"#close\"/></svg></label>" + "<svg height=\"24\" width=\"24\" viewBox=\"0 0 24 24\" preserveAspectRatio=\"xMidYMid meet\" class=\"room-select__icon\"><use xlink:href=\"#hotel-bed\"/></svg>" + "<h4 class=\"font--align-center\">Wie möchten Sie reisen?</h4>";
    var closeWrap = "</div>";
    links.forEach(function (item, iterator) {
      if (bookable[iterator] === "sold-out") {
        wrapContent += "<a class=\"button button--expanded button--primary\" href=\"" + item + "\">" + rooms[iterator] + " (auf Anfrage)" + "</a>";
      } else if (bookable[iterator] === "closed") {
        wrapContent += "<p>" + rooms[iterator] + " - nicht mehr buchbar</p>";
      } else {
        wrapContent += "<a class=\"button button--expanded button--primary\" href=\"" + item + "\">" + rooms[iterator] + "</a>";
      }
    });
    el.addEventListener("click", function (e) {
      e.preventDefault();
      overlay.innerHTML = openWrap + wrapContent + closeWrap;
      overlay.click();
    });
  });
});
